/** Send only changed opportunity image slots; omitted slots remain stored server-side. */
export function omitUnchangedOpportunityImages(opportunities, previous) {
  return opportunities.map(opportunity => {
    const old = previous.find(item => item.id === opportunity.id);
    const section = opportunity.type === "PROJECT" ? "project_details" : "media";
    if (!opportunity[section] || !old?.[section]) return opportunity;
    const details = { ...opportunity[section] };
    for (const key of ["cover_image", "gallery"]) {
      if (JSON.stringify(details[key]) === JSON.stringify(old[section][key])) delete details[key];
    }
    return { ...opportunity, [section]: details };
  });
}
